import React, { Component } from 'react';
import './loadingScreen.css';
import ReactLoading from 'react-loading';

export default class LoadingScreen extends Component {
  render() {
    return (
      <div className="loading-screen">
        <div className="screen-loading-indicator">
        <ReactLoading
          type={'spin'}
          color={'#3498db'}
          height={'100%'}
          width={'100%'}
        />
        </div>
      </div>
    );
  }
}
